import React, { useEffect, useState } from "react";
import { Card, Accordion, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useToasts } from "react-toast-notifications";

import { getSettings, updateSettings } from "../../services/Settings";
import InfoBox from "../system/InfoBox";
import Loading from "../system/Loading";
import ParametersForm from "./ParametersForm";
import {
  serviceActions,
  useServiceReducer,
} from "../../reducers/serviceReducer";

export default function InputWorkerCard({ worker, ...props }) {
  const { addToast } = useToasts();

  const [serviceState, serviceDispatch] = useServiceReducer();
  const [workerConfig, setWorkerConfig] = useState(null);

  useEffect(() => {
    loadWorkerConfig();
  }, []);

  async function loadWorkerConfig() {
    serviceDispatch({ type: serviceActions.LOADING });
    try {
      const result = await getSettings(worker.config_key);
      setWorkerConfig(result.val);
      serviceDispatch({ type: serviceActions.SUCCESS });
    } catch (err) {
      setWorkerConfig(null);
      serviceDispatch({ type: serviceActions.ERROR, payload: err.message });
    }
  }

  async function updateWorkerSettings(values) {
    serviceDispatch({ type: serviceActions.LOADING });
    try {
      await updateSettings(worker.config_key, values);
      addToast(`${worker.name} update successful`, { appearance: "success" });
      loadWorkerConfig();
    } catch (err) {
      addToast(`${worker.name} update failed`, { appearance: "error" });
      serviceDispatch({ type: serviceDispatch, payload: err.message });
    }
  }

  function cardClass() {
    const base = "card mb-4 ";
    if (serviceState.loading) {
      return `${base} text-dark`;
    } else {
      if (!workerConfig) {
        return `${base} bg-danger text-white`;
      } else {
        return workerConfig.running
          ? `${base} bg-success text-white`
          : `${base} bg-warning text-white`;
      }
    }
  }

  function runningControl() {
    return (
      <Form.Check
        onChange={(e) => {
          updateWorkerSettings({ running: e.target.checked });
        }}
        checked={workerConfig.running}
        type="switch"
        id="custom-switch"
        label={workerConfig.running ? "Running" : "Stopped"}
      />
    );
  }

  function displayDetails() {
    if (!serviceState.loading) {
      if (!workerConfig) {
        return (
          <InfoBox
            keyv={`wcm_${worker.name}`}
            type="info"
            message="There is no configuration record for this input worker in the system."
          />
        );
      } else {
        return (
          <React.Fragment>
            <div className="clearfix">
              <div className="float-right ">{runningControl()}</div>
            </div>
            <ParametersForm
              params={Object.entries(workerConfig.params)}
              onSubmit={(values) => {
                updateWorkerSettings(values);
              }}
            />
          </React.Fragment>
        );
      }
    } else {
      return <Loading isLoading={serviceState.loading} size="xs" />;
    }
  }

  return (
    <Accordion>
      <Card className={cardClass()}>
        <Card.Header>{worker.name}</Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body className="bg-light text-dark">
            {displayDetails()}
          </Card.Body>
        </Accordion.Collapse>
        <Accordion.Toggle as={Card.Footer} eventKey="0">
          <div className="d-flex align-items-center justify-content-between">
            Configuration details
            <div className="small text-white">
              <FontAwesomeIcon icon="angle-right" />
            </div>
          </div>
        </Accordion.Toggle>
      </Card>
    </Accordion>
  );
}
